// extracted by mini-css-extract-plugin
export var container = "styles-module--container--4bc3e";
export var input = "styles-module--input--d5cb1";
export var searchArea = "styles-module--searchArea--fd8fe";